export default function StatCard({
  icon,
  label,
  value,
  sub,
  color = "#38bdf8",
  title,
}) {
  return (
    <div
      title={title}
      style={{
        background: "linear-gradient(135deg,#0f172a,#1e293b)",
        border: `1px solid ${color}33`,
        borderRadius: 14,
        padding: "16px 18px",
        boxShadow: `0 0 20px ${color}15`,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 6,
          marginBottom: 6,
        }}
      >
        <span style={{ fontSize: 18 }}>{icon}</span>
        <span style={{ color: "#94a3b8", fontSize: 12 }}>{label}</span>
      </div>
      <div style={{ color, fontSize: 22, fontWeight: 800 }}>{value}</div>
      {sub && (
        <div style={{ color: "#64748b", fontSize: 11, marginTop: 3 }}>
          {sub}
        </div>
      )}
    </div>
  );
}
